import React from "react";

import { ITaxonomyTermProjects } from "../../pages/projects";
import styled from "../../theme/styled";
import {
  colourHelper,
  fontLineHeightHelper,
  fontSizeHelper
} from "../../theme/theme-helper";
import Link from "../link";

interface ITags {
  data: {
    allTaxonomyTermProjects: {
      edges: ITaxonomyTermProjects[];
    };
  };
}

const Tags = styled.ul`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  padding-top: 0.8rem;
  padding-left: 0;
  padding-bottom: 0;
  list-style: none;
  font-size: ${({ theme }) => fontSizeHelper({
    theme,
    variant: "body_1"
  })};
  line-height: ${({ theme }) =>
    fontLineHeightHelper({
      theme,
      variant: "small"
    })};

  @media (min-width: 480px) {
    flex-direction: row;
    align-items: center;
  }

  @media (min-width: 600px) {
    padding-top: 1.8rem;
  }

  @media (min-width: 1280px) {
    font-size: ${({ theme }) => fontSizeHelper({
    theme,
    variant: "body_2"
  })};
  }
`;

const Tag = styled.li`
  margin-bottom: 0;
  padding-top: 0.6rem;
  padding-bottom: 0;

  a {
    display: inline-block;
    margin-bottom: 0.4rem;
    padding-bottom: 0.2rem;
    text-decoration: none;
    color: inherit;
    border-bottom: 0.2rem solid transparent;

    &.active,
    &:hover {
      color: ${({ theme }) => colourHelper({
    theme,
    variant: "black"
  })};
    }

    &.active {
      border-bottom-color: ${({ theme }) =>
    colourHelper({
      theme,
      variant: "black"
    })};
    }
  }

  @media (min-width: 480px) {
    padding-top: 1.4rem;
    padding-right: 0.8rem;
    width: 50%;
  }

  @media (min-width: 600px) {
    padding-top: 1.8rem;
    width: 33%;
  }

  @media (min-width: 768px) {
    width: 25%;
  }

  @media (min-width: 1024px) {
    width: 20%;
  }
`;

const TagsWrapper = ({ data }: ITags) => {
  return (
    <Tags>
      <Tag>
        <Link
          activeClassName="active"
          href="/projects"
          type="none"
          underlinecolor="black"
        >
          Featured
        </Link>
      </Tag>

      {data.allTaxonomyTermProjects.edges.map(
        (tag: ITaxonomyTermProjects, index: number) => (
          <Tag key={index}>
            <Link
              activeClassName="active"
              href={tag.node.path.alias}
              getProps={({ isPartiallyCurrent }) => {
                return isPartiallyCurrent ? { className: "active" } : {};
              }}
              underlinecolor="black"
            >
              {tag.node.name}
            </Link>
          </Tag>
        )
      )}
    </Tags>
  );
};

export default TagsWrapper;
